import { CircularProgress, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

type Props = {
  isLoading: boolean;
};

export function FooterLoader(props: Props): React.ReactElement | null {
  const { isLoading } = props;
  const classes = useStyles();

  if (isLoading) {
    return (
      <div className={classes.root}>
        <CircularProgress />
      </div>
    );
  } else {
    return null;
  }
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(12),
    textAlign: 'center',
  },
}));
